/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import CheckInEventList from './checkInEventList';
import CheckInEventDetail from './checkInEventDetail/index';
import { useParams } from 'react-router-dom';
import { GET } from '/client/src/api';

type PropsType = {
    history: {
        push: (string) => void
    }
};

const CheckIn = ({ history }: PropsType): React.Element<'div'> => {
    const { eventId: eventIdFromParams } = useParams();
    const [tab, setTab] = React.useState('eventList');
    const [eventId, setEventId] = React.useState(eventIdFromParams);
    const [eventName, setEventName] = React.useState(null);
    const [eventScheduleId, setEventScheduleId] = React.useState(null);

    const handleEventData = (id: number | string, eventScheduleId: number | string) => {
        if (!id) return;
        setEventId(id);
        setEventScheduleId(eventScheduleId);
        history.push(`/check-in/${id}`);
    };

    const fetchEvent = async () => {
        try {
            const { result } = await GET(`/api/v1/1/events/${eventId}/detail`);

            setEventName(result.name);
            setEventScheduleId(result.schedules[0]?.id);
          } catch (e) {
            console.log(e);
          }
    };

    const resetEvent = () => {
        setEventId(null);
        setEventName(null);
        setEventScheduleId(null);
        setTab('eventList');
    };

    React.useEffect(() => {
        if (eventId) {
            setTab('eventCheckIn');
            fetchEvent();
        }
    }, [eventId]);


    return (
        <Modal
          opened
          ignoreOutsideClick
          altView
          fullScreen
        >
            <div className="modal-dialog customModal checkInModal" role="document">
                <div className="modal-custom-header">
                    <span className="sparxo-logo1" />
                    <span>{eventName || 'Check-In'}</span>
                </div>
                <div className="modal-body">
                    {tab === 'eventList' ?
                        <CheckInEventList handleEventData={handleEventData} />
                        :
                        <CheckInEventDetail eventId={eventId} eventScheduleId={eventScheduleId} handleResetEvent={resetEvent}/>
                    }
                </div>
            </div>
        </Modal>
    );
};

export default CheckIn;